// *****配货端客户模块
export default [
  {
    path: "/replenishment", //配货端客户-配货单列表
    name: "Replenishment",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/Replenishment"),
  },
  {
    path: "/replenishmentShare", // 配货平台-分享直达入口（免登录，仅用于分享查看/定位视频）
    name: "ReplenishmentShare",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: false,
    },
    component: () => import("@pages/replenishmentClient/Replenishment"),
  },
  {
    path: "/replenishmentOrder", //配货端客户-订单列表
    name: "ReplenishmentOrder",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/ReplenishmentOrder"),
  },
  {
    path: "/replenishmentOrderDetail", //配货端客户-订单详情
    name: "ReplenishmentOrderDetail",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/ReplenishmentOrderDetail"),
  },
  {
    path: "/orderSuccess", //配货端客户-下单成功
    name: "OrderSuccess",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/OrderSuccess"),
  },
  {
    path: "/replenishmentFavorite", //配货端-我的收藏
    name: "ReplenishmentFavorite",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/ReplenishmentFavorite"),
  },
  {
    path: "/replenishmentMine", //配货端-我的
    name: "ReplenishmentMine",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/ReplenishmentMine"),
  },
];

